import { Referral } from '@/generated/proto/bridge/models/referrals'
import { ProtobufAnyMessage } from '@/types'

export type SetReferralFormValues = {
  creator: string
  referral: {
    id: string
    withdrawalAddress: string
    commissionRate: string
  }
}

export type RemoveReferralFormValues = {
  creator: string
  id: string
}

export function buildSetReferralMessage(values: SetReferralFormValues): {
  messages: ProtobufAnyMessage[]
} {
  const referral: Referral = {
    id: Number(values.referral.id),
    withdrawalAddress: values.referral.withdrawalAddress,
    commissionRate: values.referral.commissionRate,
  }

  return {
    messages: [
      {
        '@type': '/core.bridge.MsgSetReferral',
        creator: values.creator,
        referral,
      },
    ],
  }
}

export function buildRemoveReferralMessage(values: RemoveReferralFormValues): {
  messages: ProtobufAnyMessage[]
} {
  return {
    messages: [
      {
        '@type': '/core.bridge.MsgRemoveReferral',
        creator: values.creator,
        id: Number(values.id),
      },
    ],
  }
}
